module.exports = __webpack_public_path__ + "images/warning_icon_885a0921be9f85a7d9caa40358217c3e.svg";